module.exports = __webpack_public_path__ + "static/hue&cry-8f6356a1f325a49cd7c6fcbb60ff63e9.png";